import {
  AutocompleteGenericEntity,
  SingleAutocomplete,
  SingleAutocompleteProps,
} from '@australiangreens/ag-internal-components';
import { SyntheticEvent, useState } from 'react';

import { FieldMetaData } from './types';

type SingleAutocompleteByIdTFCProps<T extends AutocompleteGenericEntity> = Omit<
  SingleAutocompleteProps<T>,
  'value' | 'onChange'
> & {
  onChange: (value: number, fieldMetaData: FieldMetaData) => void;
  /** Entity for Restart pre-fill */
  initialValue?: T | null;
};

export default function SingleAutocompleteByIdTFC<T extends AutocompleteGenericEntity>({
  onChange,
  initialValue = null,
  ...props
}: SingleAutocompleteByIdTFCProps<T>) {
  const [value, setValue] = useState<T | null>(initialValue ?? null);

  const handleOnChange = (_event: SyntheticEvent<Element, Event>, newValue: T | null) => {
    setValue(newValue);

    let idVal;
    if (newValue === null) idVal = -1;
    else if (typeof newValue.id === 'number') idVal = newValue.id;
    else idVal = parseInt(newValue.id);

    const state = idVal === -1 ? 'empty' : 'valid';
    const fieldMetaData = { state, error: null } as FieldMetaData;

    onChange(idVal, fieldMetaData);
  };

  return (
    <SingleAutocomplete
      onChange={handleOnChange}
      value={value}
      {...props}
      textFieldColor="secondary"
    />
  );
}
